/** @format */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { NavLink } from 'fe-appdir-comp-link';
import theme, { rems } from 'fe-appdir-lib-theme';
import { StatelessDrawer } from 'fe-website-comp-drawer';
import AuthButtons from './AuthButtons';

const PROP_TYPES = {
  authButtons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      type: PropTypes.oneOf(['default', 'cta', 'standard', 'primary', 'ghost']),
      href: PropTypes.string,
      to: PropTypes.string,
      gaTrackId: PropTypes.string,
    }),
  ),
  navLinks: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      to: PropTypes.string,
      gaTrackId: PropTypes.string,
    }),
  ),
};

const Wrapper = styled.div`
  margin-top: ${rems(18)};

  @media (min-width: ${theme.breakpointMobileNav}) {
    display: none;
  }
`;

const MobileNavLink = styled(NavLink)`
  padding: ${theme.spacingXl} ${theme.spacingMd};
  border-bottom: 1px solid ${theme.colorGrey90};
  font-size: ${theme.fontSizeBase};
  font-family: ${theme.fontFamilyPrimary};
  text-decoration: none;
  color: ${theme.colorBase};
  font-weight: ${theme.fontWeightSemibold};
  display: block;

  :hover {
    color: ${theme.colorBrandPrimary};
  }

  :first-of-type {
    border-top: 1px solid ${theme.colorGrey90};
  }

  &.active {
    // Active link state goes here?
  }
`;

class MobileNav extends React.Component {
  state = {
    isOpen: false,
  };

  toggleOpen = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  render = () => {
    const { authButtons, navLinks } = this.props;
    const { isOpen } = this.state;
    return (
      <Wrapper>
        <StatelessDrawer
          isOpen={isOpen}
          offsetY={`calc(${theme.headerHeightMobile} - 1px)`}
          maxWidth={'400px'}
          id="appDirMobileNav"
          onClick={this.toggleOpen}
          overlayOnOpen
        >
          <AuthButtons buttons={authButtons} />
          {navLinks && navLinks.length
            ? navLinks.map((link, i) => (
                <MobileNavLink onClick={this.toggleOpen} key={i} {...link}>
                  {link.label}
                </MobileNavLink>
              ))
            : null}
        </StatelessDrawer>
      </Wrapper>
    );
  };
}

MobileNav.propTypes = PROP_TYPES;

export { MobileNav };
